import { EndPoints } from '../../common/enums/enums';
import { api } from './api';

export const globalSearchServices = api.injectEndpoints({
  endpoints: build => ({
    getOrders: build.query({
      query: ({ search, groupedFilters, page }) => ({
        url: EndPoints.ORDERS.UNAPPROVED.GET_ORDERS.ENDPOINT,
        method: EndPoints.ORDERS.UNAPPROVED.GET_ORDERS.METHOD,
        body: {
          pageSize: 25,
          pageNumber: page,
          order: 'desc',
          orderBy: 'date',
          filters: [],
          groupedFilters,
          searchQuery: search,
        },
      }),
      serializeQueryArgs({ endpointName, queryArgs }) {
        const args = { ...queryArgs };
        delete args.page;
        return `${endpointName}(${JSON.stringify(args)})`;
      },
      forceRefetch({ currentArg, previousArg }) {
        if (!previousArg) return true;
        return (
          currentArg.search !== previousArg.search ||
          currentArg.page > previousArg.page
        );
      },
      merge(currentData, responseData) {
        currentData.pagination = responseData.pagination;
        currentData.orders.push(...responseData.orders);
      },
    }),
  }),
});

export const { useGetOrdersQuery } = globalSearchServices;
